import { GoogleAuthProvider, signInWithRedirect } from "firebase/auth"

import { firebaseAuth } from "@plugins/session/auth/firebase"

export function handleGoogleSignIn() {
    let redirectPath = window.location.pathname || "/"
    if (!redirectPath.startsWith("/")) {
        redirectPath = "/" + redirectPath
    }

    const provider = new GoogleAuthProvider()
    provider.addScope("profile")
    provider.addScope("email")

    provider.setCustomParameters({
        prompt: "select_account",
        redirect_uri: window.location.origin + redirectPath,
    })
    signInWithRedirect(firebaseAuth, provider)
}
